import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, vShow as _vShow, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createBlock as _createBlock, withCtx as _withCtx } from "vue";
import _imports_0 from '@/assets/hebeidaxue/redstar.png';
const _hoisted_1 = {
  class: "pophead"
};
const _hoisted_2 = {
  class: "phleft"
};
const _hoisted_3 = {
  class: "title"
};
const _hoisted_4 = {
  class: "views"
};
const _hoisted_5 = {
  class: "popcontent"
};
const _hoisted_6 = {
  class: "popconleft"
};
const _hoisted_7 = ["onClick"];
const _hoisted_8 = {
  class: "popconright"
};
const _hoisted_9 = {
  class: "imgcontent"
};
const _hoisted_10 = {
  class: "swiper-wrapper"
};
const _hoisted_11 = ["src"];
const _hoisted_12 = {
  class: "textcontainer"
};
const _hoisted_13 = ["innerHTML"];
const _hoisted_14 = {
  class: "otherdesc"
};
const _hoisted_15 = {
  key: 0
};
const _hoisted_16 = ["href"];
const _hoisted_17 = {
  key: 1
};
const _hoisted_18 = {
  class: "ul_data"
};
const _hoisted_19 = {
  key: 0
};
const _hoisted_20 = {
  class: "li_img"
};
const _hoisted_21 = ["src"];
const _hoisted_22 = {
  class: "li_title"
};
const _hoisted_23 = {
  class: "li_value"
};
const _hoisted_24 = {
  class: "innerbox"
};
const _hoisted_25 = {
  key: 0,
  class: "ul2"
};
const _hoisted_26 = ["onClick"];
const _hoisted_27 = {
  href: "javascript:void(0)"
};
const _hoisted_28 = {
  class: "imgbox"
};
const _hoisted_29 = ["src"];
const _hoisted_30 = {
  class: "innerdetail"
};
const _hoisted_31 = {
  class: "videobox"
};
const _hoisted_32 = ["src"];
const _hoisted_33 = {
  key: 1,
  class: ""
};
const _hoisted_34 = {
  class: "innerbox"
};
const _hoisted_35 = {
  key: 0,
  class: "ul1"
};
const _hoisted_36 = {
  class: "audiobox"
};
const _hoisted_37 = {
  key: 1,
  class: ""
};
const _hoisted_38 = {
  key: 0,
  class: "innerbox"
};
const _hoisted_39 = {
  class: "type_ul"
};
const _hoisted_40 = ["onClick"];
const _hoisted_41 = {
  key: 0,
  class: "list"
};
const _hoisted_42 = ["onClick"];
const _hoisted_43 = ["src"];
const _hoisted_44 = {
  key: 1,
  class: "itemInfo"
};
const _hoisted_45 = {
  class: "text-truncate-1"
};
const _hoisted_46 = {
  class: "itemInfoAuthor"
};
const _hoisted_47 = {
  class: "goodhomework"
};
const _hoisted_48 = {
  key: 0,
  class: "scrollHomework"
};
const _hoisted_49 = {
  class: "top"
};
const _hoisted_50 = ["src"];
const _hoisted_51 = {
  class: "titleinfo"
};
const _hoisted_52 = {
  key: 0,
  class: "title"
};
const _hoisted_53 = {
  key: 1,
  class: "author"
};
const _hoisted_54 = {
  key: 2,
  class: "department"
};
const _hoisted_55 = ["innerHTML"];
const _hoisted_56 = {
  key: 0,
  class: ""
};
const _hoisted_57 = {
  key: 1,
  class: "innerbox"
};
const _hoisted_58 = {
  class: "type_ul"
};
const _hoisted_59 = ["onClick"];
const _hoisted_60 = {
  key: 0,
  class: "list"
};
const _hoisted_61 = ["onClick"];
const _hoisted_62 = ["src"];
const _hoisted_63 = {
  key: 1,
  class: "itemInfo1 text-truncate-2"
};
const _hoisted_64 = {
  class: "goodhomework"
};
const _hoisted_65 = {
  key: 0,
  class: "scrollHomework"
};
const _hoisted_66 = {
  class: "top"
};
const _hoisted_67 = ["src"];
const _hoisted_68 = {
  class: "titleinfo"
};
const _hoisted_69 = {
  key: 0,
  class: "title"
};
const _hoisted_70 = {
  key: 1,
  class: "author"
};
const _hoisted_71 = {
  key: 2,
  class: "department"
};
const _hoisted_72 = ["innerHTML"];
const _hoisted_73 = {
  key: 0,
  class: ""
};
const _hoisted_74 = {
  key: 2,
  class: "innerbox"
};
const _hoisted_75 = {
  class: "type_ul"
};
const _hoisted_76 = ["onClick"];
const _hoisted_77 = {
  key: 0,
  class: "list"
};
const _hoisted_78 = ["onClick"];
const _hoisted_79 = ["src"];
const _hoisted_80 = {
  key: 1,
  class: "itemInfo1 text-truncate-2"
};
const _hoisted_81 = {
  class: "goodhomework"
};
const _hoisted_82 = {
  key: 0,
  class: "scrollHomework"
};
const _hoisted_83 = {
  class: "top"
};
const _hoisted_84 = ["src"];
const _hoisted_85 = {
  class: "titleinfo"
};
const _hoisted_86 = {
  key: 0,
  class: "title"
};
const _hoisted_87 = {
  key: 1,
  class: "author"
};
const _hoisted_88 = {
  key: 2,
  class: "department"
};
const _hoisted_89 = ["innerHTML"];
const _hoisted_90 = {
  key: 0,
  class: ""
};
const _hoisted_91 = {
  class: "funbox"
};
const _hoisted_92 = {
  key: 0,
  class: "li4"
};
const _hoisted_93 = ["src"];
const _hoisted_94 = {
  key: 1,
  class: "icon-home"
};
const _hoisted_95 = {
  key: 1,
  class: "li2"
};
const _hoisted_96 = ["src"];
const _hoisted_97 = {
  key: 1,
  class: "icon-720"
};
const _hoisted_98 = {
  key: 2,
  class: "li3"
};
const _hoisted_99 = ["src"];
const _hoisted_100 = {
  key: 1,
  class: "icon-topic"
};
const _hoisted_101 = {
  key: 3,
  class: "li1"
};
const _hoisted_102 = {
  key: 4,
  class: "li1"
};
const _hoisted_103 = ["src"];
const _hoisted_104 = ["src"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_empty = _resolveComponent("el-empty");
  const _component_vue_audio = _resolveComponent("vue-audio");
  const _component_Pagination = _resolveComponent("Pagination");
  const _component_Microphone = _resolveComponent("Microphone");
  const _component_el_icon = _resolveComponent("el-icon");
  const _component_Mute = _resolveComponent("Mute");
  const _component_el_button = _resolveComponent("el-button");
  return _openBlock(), _createElementBlock("div", null, [_ctx.$attrs.popshowflag && _ctx.$attrs.detail ? (_openBlock(), _createElementBlock("div", {
    key: 0,
    class: _normalizeClass(["popcontainer-style3", ['fid' + _ctx.$route.query.fid, {
      mobile: _ctx.$attrs.isMobile
    }, {
      useSvw: _ctx.$attrs.id === 1
    }]])
  }, [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("h2", _hoisted_3, _toDisplayString(_ctx.$attrs.detail.place_name), 1), _createElementVNode("div", _hoisted_4, [_cache[10] || (_cache[10] = _createElementVNode("div", {
    class: "eye"
  }, null, -1)), _createTextVNode(" " + _toDisplayString(_ctx.$attrs.detail.view ? _ctx.$attrs.detail.view : 0), 1)])]), _createElementVNode("div", {
    class: "closediv",
    onClick: _cache[0] || (_cache[0] = (...args) => $options.closePop && $options.closePop(...args))
  }, _cache[11] || (_cache[11] = [_createElementVNode("span", {
    class: "icon-close"
  }, null, -1)]))]), _createElementVNode("div", _hoisted_5, [_createElementVNode("div", _hoisted_6, [_createElementVNode("ul", null, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.popLeftArr, (item, index) => {
    return _openBlock(), _createElementBlock("li", {
      class: _normalizeClass([{
        active: $data.popLeftIndex === item.id
      }, "leftselect"]),
      key: index,
      onClick: $event => $options.popLeftHandle(item.id)
    }, _toDisplayString(item.name), 11, _hoisted_7);
  }), 128))])]), _createElementVNode("div", _hoisted_8, [_withDirectives(_createElementVNode("div", {
    class: _normalizeClass(["innerbox", {
      'paddingbottom': $data.dataList.length > 0
    }])
  }, [_withDirectives(_createElementVNode("div", _hoisted_9, [_createElementVNode("div", {
    class: _normalizeClass(["swiper-container swiperbox visibleitem", {
      on: _ctx.$attrs.detail.currentShowtype === 'banner'
    }]),
    ref: "swipercontainer"
  }, [_createElementVNode("div", _hoisted_10, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.$attrs.detail.banner, (item, i) => {
    return _openBlock(), _createElementBlock("div", {
      class: "swiper-slide",
      key: i
    }, [_createElementVNode("img", {
      src: $options.sethandleHttp(item.fileUrl)
    }, null, 8, _hoisted_11), _createElementVNode("h4", null, [_createElementVNode("span", null, _toDisplayString(i + 1), 1), _cache[12] || (_cache[12] = _createTextVNode("/")), _createElementVNode("span", null, _toDisplayString(_ctx.$attrs.detail.banner.length), 1)])]);
  }), 128))])], 2)], 512), [[_vShow, _ctx.$attrs.detail.banner && _ctx.$attrs.detail.banner.length > 0]]), _cache[15] || (_cache[15] = _createElementVNode("div", {
    class: "intropic"
  }, null, -1)), _createElementVNode("div", _hoisted_12, [_createElementVNode("div", {
    class: "infodesc",
    innerHTML: $options.replaceIframeSrc(_ctx.$attrs.detail.introduce)
  }, null, 8, _hoisted_13)]), _createElementVNode("div", _hoisted_14, [_ctx.$attrs.detail.telphone !== undefined && _ctx.$attrs.detail.telphone !== '' ? (_openBlock(), _createElementBlock("p", _hoisted_15, [_createElementVNode("a", {
    href: `tel:${_ctx.$attrs.detail.telphone}`
  }, [_cache[13] || (_cache[13] = _createElementVNode("span", {
    class: "icon-tel"
  }, null, -1)), _createTextVNode(" " + _toDisplayString(_ctx.$attrs.detail.telphone), 1)], 8, _hoisted_16)])) : _createCommentVNode("", true), _ctx.$attrs.detail.route && _ctx.$attrs.detail.route.length > 0 && Object.keys(_ctx.$attrs.detail.route[0]).length > 1 ? (_openBlock(), _createElementBlock("p", _hoisted_17, [_cache[14] || (_cache[14] = _createElementVNode("span", {
    class: "icon-location1"
  }, null, -1)), _createTextVNode(" " + _toDisplayString($options.getAddress(_ctx.$attrs.detail.route)), 1)])) : _createCommentVNode("", true)])], 2), [[_vShow, $data.popLeftIndex === 0]]), _withDirectives(_createElementVNode("ul", _hoisted_18, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.dataList, (item, index) => {
    return _openBlock(), _createElementBlock(_Fragment, {
      key: index
    }, [item.value !== '' ? (_openBlock(), _createElementBlock("li", _hoisted_19, [_createElementVNode("div", _hoisted_20, [_createElementVNode("img", {
      src: item.pic[0].fileUrl
    }, null, 8, _hoisted_21)]), _createElementVNode("div", _hoisted_22, _toDisplayString(item.title), 1), _createElementVNode("div", _hoisted_23, _toDisplayString(item.value), 1)])) : _createCommentVNode("", true)], 64);
  }), 128))], 512), [[_vShow, $data.popLeftIndex === 0 && $data.dataList.length > 0]]), _withDirectives(_createElementVNode("div", _hoisted_24, [_ctx.$attrs.detail.video !== '' ? (_openBlock(), _createElementBlock("ul", _hoisted_25, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.$attrs.detail.video, (item, index) => {
    return _openBlock(), _createElementBlock("li", {
      key: index,
      onClick: $event => $options.videoItemHandle(item)
    }, [_createElementVNode("a", _hoisted_27, [_createElementVNode("div", _hoisted_28, [_createElementVNode("img", {
      src: $options.sethandleHttp(item.fileUrl),
      alt: ""
    }, null, 8, _hoisted_29)]), _createElementVNode("h2", null, _toDisplayString(item.title), 1)])], 8, _hoisted_26);
  }), 128))])) : _createCommentVNode("", true), _withDirectives(_createElementVNode("div", _hoisted_30, [_createElementVNode("div", {
    class: "closediv",
    onClick: _cache[1] || (_cache[1] = (...args) => $options.closevideoItem && $options.closevideoItem(...args))
  }, _cache[16] || (_cache[16] = [_createElementVNode("span", {
    class: "icon-close"
  }, null, -1)])), _createElementVNode("h2", null, _toDisplayString($data.videoitem.title), 1), _createElementVNode("div", _hoisted_31, [_createElementVNode("video", {
    src: $data.videoitem.url,
    controls: ""
  }, null, 8, _hoisted_32)])], 512), [[_vShow, $data.videoitemflag && $data.videoitem !== '']]), _ctx.$attrs.detail.video === '' ? (_openBlock(), _createElementBlock("div", _hoisted_33, [_createVNode(_component_el_empty, {
    description: "暂无数据"
  })])) : _createCommentVNode("", true)], 512), [[_vShow, $data.popLeftIndex === 2]]), _withDirectives(_createElementVNode("div", _hoisted_34, [_ctx.$attrs.detail.audio !== '' ? (_openBlock(), _createElementBlock("ul", _hoisted_35, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.$attrs.detail.audio, (item, index) => {
    return _openBlock(), _createElementBlock("li", {
      key: index
    }, [_createElementVNode("h2", null, _toDisplayString(item.title), 1), _createElementVNode("div", _hoisted_36, [_createVNode(_component_vue_audio, {
      file: item.url
    }, null, 8, ["file"])])]);
  }), 128))])) : _createCommentVNode("", true), _ctx.$attrs.detail.audio === '' ? (_openBlock(), _createElementBlock("div", _hoisted_37, [_createVNode(_component_el_empty, {
    description: "暂无数据"
  })])) : _createCommentVNode("", true)], 512), [[_vShow, $data.popLeftIndex === 3]]), $data.popLeftIndex === 4 ? (_openBlock(), _createElementBlock("div", _hoisted_38, [_withDirectives(_createElementVNode("div", {
    class: _normalizeClass(["goodhomeworklist", {
      'height100': $data.teachCourse.length != 0
    }])
  }, [_createElementVNode("ul", _hoisted_39, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.teachType, (item, index) => {
    return _openBlock(), _createElementBlock("li", {
      class: _normalizeClass({
        'active': $data.typeIndex === index
      }),
      onClick: $event => $options.typeClick(item, index),
      key: index
    }, _toDisplayString(item.title), 11, _hoisted_40);
  }), 128))]), $data.teachCourseTotal != 0 ? (_openBlock(), _createElementBlock("div", _hoisted_41, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.teachCourse, (item, index) => {
    return _openBlock(), _createElementBlock("div", {
      class: "item",
      key: index,
      onClick: $event => $options.toDetail(item.itemformdata)
    }, [item.itemformdata.yxzp_cover.length > 0 ? (_openBlock(), _createElementBlock("img", {
      key: 0,
      class: "itemPic",
      src: item.itemformdata.yxzp_cover[0].fileUrl
    }, null, 8, _hoisted_43)) : _createCommentVNode("", true), item.itemformdata.yxzp_title ? (_openBlock(), _createElementBlock("div", _hoisted_44, [_createElementVNode("span", _hoisted_45, _toDisplayString(item.itemformdata.yxzp_title), 1), _createElementVNode("span", _hoisted_46, " 作者：" + _toDisplayString(item.itemformdata.yxzp_author), 1)])) : _createCommentVNode("", true)], 8, _hoisted_42);
  }), 128))])) : _createCommentVNode("", true), $data.teachCourse.length != 0 ? (_openBlock(), _createBlock(_component_Pagination, {
    key: 1,
    class: "page",
    "total-pages": $data.teachCourseTotal,
    "current-page": $data.currentPage,
    onPageChange: $options.handlePageChange
  }, null, 8, ["total-pages", "current-page", "onPageChange"])) : _createCommentVNode("", true)], 2), [[_vShow, !$data.showGood]]), _withDirectives(_createElementVNode("div", _hoisted_47, [_createElementVNode("div", {
    class: "homeback",
    onClick: _cache[2] || (_cache[2] = (...args) => $options.homeback && $options.homeback(...args))
  }), $data.currentItem !== null ? (_openBlock(), _createElementBlock("div", _hoisted_48, [_createElementVNode("div", _hoisted_49, [$data.currentItem.yxzp_cover ? (_openBlock(), _createElementBlock("img", {
    key: 0,
    class: "toppic",
    src: $data.currentItem.yxzp_cover[0].fileUrl
  }, null, 8, _hoisted_50)) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_51, [$data.currentItem.yxzp_title ? (_openBlock(), _createElementBlock("div", _hoisted_52, [_cache[17] || (_cache[17] = _createElementVNode("img", {
    src: _imports_0,
    alt: ""
  }, null, -1)), _createTextVNode(" " + _toDisplayString($data.currentItem.yxzp_title) + " ", 1), _cache[18] || (_cache[18] = _createElementVNode("div", {
    class: "titlebar1"
  }, null, -1)), _cache[19] || (_cache[19] = _createElementVNode("div", {
    class: "titlebar2"
  }, null, -1))])) : _createCommentVNode("", true), $data.currentItem.yxzp_author ? (_openBlock(), _createElementBlock("div", _hoisted_53, " 作者姓名：" + _toDisplayString($data.currentItem.yxzp_author), 1)) : _createCommentVNode("", true), $data.currentItem.department ? (_openBlock(), _createElementBlock("div", _hoisted_54, "作者单位：" + _toDisplayString($data.currentItem.department), 1)) : _createCommentVNode("", true)])]), $data.currentItem.yxzp_content ? (_openBlock(), _createElementBlock("div", {
    key: 0,
    class: "homeworkcontent",
    innerHTML: $data.currentItem.yxzp_content
  }, null, 8, _hoisted_55)) : _createCommentVNode("", true)])) : _createCommentVNode("", true)], 512), [[_vShow, $data.showGood && $data.teachCourse.length !== 0]]), $data.teachCourse.length == 0 ? (_openBlock(), _createElementBlock("div", _hoisted_56, [_createVNode(_component_el_empty, {
    description: "暂无数据"
  })])) : _createCommentVNode("", true)])) : _createCommentVNode("", true), $data.popLeftIndex === 5 ? (_openBlock(), _createElementBlock("div", _hoisted_57, [_withDirectives(_createElementVNode("div", {
    class: _normalizeClass(["goodhomeworklist", {
      'height100': $data.journalbooks.length != 0
    }])
  }, [_createElementVNode("ul", _hoisted_58, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.journalType, (item, index) => {
    return _openBlock(), _createElementBlock("li", {
      class: _normalizeClass({
        'active': $data.typeIndex === index
      }),
      onClick: $event => $options.typeClick(item, index),
      key: index
    }, _toDisplayString(item.title), 11, _hoisted_59);
  }), 128))]), $data.journalbooksTotal != 0 ? (_openBlock(), _createElementBlock("div", _hoisted_60, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.journalbooks, (item, index) => {
    return _openBlock(), _createElementBlock("div", {
      class: "item",
      key: index,
      onClick: $event => $options.toDetail(item.itemformdata)
    }, [item.itemformdata.ysal_cover ? (_openBlock(), _createElementBlock("img", {
      key: 0,
      class: "itemPic",
      src: item.itemformdata.ysal_cover[0].fileUrl
    }, null, 8, _hoisted_62)) : _createCommentVNode("", true), item.itemformdata.ysal_title ? (_openBlock(), _createElementBlock("div", _hoisted_63, _toDisplayString(item.itemformdata.ysal_title), 1)) : _createCommentVNode("", true)], 8, _hoisted_61);
  }), 128))])) : _createCommentVNode("", true), $data.journalbooks.length != 0 ? (_openBlock(), _createBlock(_component_Pagination, {
    key: 1,
    class: "page",
    "total-pages": $data.journalbooksTotal,
    "current-page": $data.currentPage,
    onPageChange: $options.handlePageChange
  }, null, 8, ["total-pages", "current-page", "onPageChange"])) : _createCommentVNode("", true)], 2), [[_vShow, !$data.showGood]]), _withDirectives(_createElementVNode("div", _hoisted_64, [_createElementVNode("div", {
    class: "homeback",
    onClick: _cache[3] || (_cache[3] = (...args) => $options.homeback && $options.homeback(...args))
  }), $data.currentItem !== null ? (_openBlock(), _createElementBlock("div", _hoisted_65, [_createElementVNode("div", _hoisted_66, [$data.currentItem.ysal_cover ? (_openBlock(), _createElementBlock("img", {
    key: 0,
    class: "toppic",
    src: $data.currentItem.ysal_cover[0].fileUrl
  }, null, 8, _hoisted_67)) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_68, [$data.currentItem.ysal_title ? (_openBlock(), _createElementBlock("div", _hoisted_69, [_cache[20] || (_cache[20] = _createElementVNode("img", {
    src: _imports_0,
    alt: ""
  }, null, -1)), _createTextVNode(" " + _toDisplayString($data.currentItem.ysal_title) + " ", 1), _cache[21] || (_cache[21] = _createElementVNode("div", {
    class: "titlebar1"
  }, null, -1)), _cache[22] || (_cache[22] = _createElementVNode("div", {
    class: "titlebar2"
  }, null, -1))])) : _createCommentVNode("", true), $data.currentItem.ysal_author ? (_openBlock(), _createElementBlock("div", _hoisted_70, " 作者姓名：" + _toDisplayString($data.currentItem.ysal_author), 1)) : _createCommentVNode("", true), $data.currentItem.department ? (_openBlock(), _createElementBlock("div", _hoisted_71, "作者单位：" + _toDisplayString($data.currentItem.department), 1)) : _createCommentVNode("", true)])]), $data.currentItem.ysal_content ? (_openBlock(), _createElementBlock("div", {
    key: 0,
    class: "homeworkcontent",
    innerHTML: $data.currentItem.ysal_content
  }, null, 8, _hoisted_72)) : _createCommentVNode("", true)])) : _createCommentVNode("", true)], 512), [[_vShow, $data.showGood && $data.journalbooks.length !== 0]]), $data.journalbooks.length == 0 ? (_openBlock(), _createElementBlock("div", _hoisted_73, [_createVNode(_component_el_empty, {
    description: "暂无数据"
  })])) : _createCommentVNode("", true)])) : _createCommentVNode("", true), $data.popLeftIndex === 6 ? (_openBlock(), _createElementBlock("div", _hoisted_74, [_withDirectives(_createElementVNode("div", {
    class: _normalizeClass(["goodhomeworklist", {
      'height100': $data.achievement.length != 0
    }])
  }, [_createElementVNode("ul", _hoisted_75, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.achievementType, (item, index) => {
    return _openBlock(), _createElementBlock("li", {
      class: _normalizeClass({
        'active': $data.typeIndex === index
      }),
      onClick: $event => $options.typeClick(item, index),
      key: index
    }, _toDisplayString(item.title), 11, _hoisted_76);
  }), 128))]), $data.achievementTotal != 0 ? (_openBlock(), _createElementBlock("div", _hoisted_77, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.achievement, (item, index) => {
    return _openBlock(), _createElementBlock("div", {
      class: "item",
      key: index,
      onClick: $event => $options.toDetail(item.itemformdata)
    }, [item.itemformdata.ysal_cover ? (_openBlock(), _createElementBlock("img", {
      key: 0,
      class: "itemPic",
      src: item.itemformdata.ysal_cover[0].fileUrl
    }, null, 8, _hoisted_79)) : _createCommentVNode("", true), item.itemformdata.ysal_title ? (_openBlock(), _createElementBlock("div", _hoisted_80, _toDisplayString(item.itemformdata.ysal_title), 1)) : _createCommentVNode("", true)], 8, _hoisted_78);
  }), 128))])) : _createCommentVNode("", true), $data.achievement.length != 0 ? (_openBlock(), _createBlock(_component_Pagination, {
    key: 1,
    class: "page",
    "total-pages": $data.achievementTotal,
    "current-page": $data.currentPage,
    onPageChange: $options.handlePageChange
  }, null, 8, ["total-pages", "current-page", "onPageChange"])) : _createCommentVNode("", true)], 2), [[_vShow, !$data.showGood]]), _withDirectives(_createElementVNode("div", _hoisted_81, [_createElementVNode("div", {
    class: "homeback",
    onClick: _cache[4] || (_cache[4] = (...args) => $options.homeback && $options.homeback(...args))
  }), $data.currentItem !== null ? (_openBlock(), _createElementBlock("div", _hoisted_82, [_createElementVNode("div", _hoisted_83, [$data.currentItem.ysal_cover ? (_openBlock(), _createElementBlock("img", {
    key: 0,
    class: "toppic",
    src: $data.currentItem.ysal_cover[0].fileUrl
  }, null, 8, _hoisted_84)) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_85, [$data.currentItem.ysal_title ? (_openBlock(), _createElementBlock("div", _hoisted_86, [_cache[23] || (_cache[23] = _createElementVNode("img", {
    src: _imports_0,
    alt: ""
  }, null, -1)), _createTextVNode(" " + _toDisplayString($data.currentItem.ysal_title) + " ", 1), _cache[24] || (_cache[24] = _createElementVNode("div", {
    class: "titlebar1"
  }, null, -1)), _cache[25] || (_cache[25] = _createElementVNode("div", {
    class: "titlebar2"
  }, null, -1))])) : _createCommentVNode("", true), $data.currentItem.ysal_author ? (_openBlock(), _createElementBlock("div", _hoisted_87, "作者姓名：" + _toDisplayString($data.currentItem.ysal_author), 1)) : _createCommentVNode("", true), $data.currentItem.department ? (_openBlock(), _createElementBlock("div", _hoisted_88, "作者单位：" + _toDisplayString($data.currentItem.department), 1)) : _createCommentVNode("", true)])]), $data.currentItem.ysal_introduction ? (_openBlock(), _createElementBlock("div", {
    key: 0,
    class: "homeworkcontent",
    innerHTML: $data.currentItem.ysal_introduction
  }, null, 8, _hoisted_89)) : _createCommentVNode("", true)])) : _createCommentVNode("", true)], 512), [[_vShow, $data.showGood && $data.achievement.length !== 0]]), $data.achievement.length == 0 ? (_openBlock(), _createElementBlock("div", _hoisted_90, [_createVNode(_component_el_empty, {
    description: "暂无数据"
  })])) : _createCommentVNode("", true)])) : _createCommentVNode("", true)])]), _createElementVNode("ul", _hoisted_91, [_ctx.$attrs.detail.portal_link ? (_openBlock(), _createElementBlock("li", _hoisted_92, [_createElementVNode("a", {
    onClick: _cache[5] || (_cache[5] = $event => $options.goLink(_ctx.$attrs.detail.portal_link)),
    target: "_blank"
  }, [$data.structImgdefaultValues.linkpic1 ? (_openBlock(), _createElementBlock("img", {
    key: 0,
    src: $data.structImgdefaultValues.linkpic1,
    alt: ""
  }, null, 8, _hoisted_93)) : (_openBlock(), _createElementBlock("span", _hoisted_94)), _createTextVNode(" " + _toDisplayString($data.structLabel.portal_link), 1)])])) : _createCommentVNode("", true), _ctx.$attrs.detail.virtual_link ? (_openBlock(), _createElementBlock("li", _hoisted_95, [_createElementVNode("a", {
    onClick: _cache[6] || (_cache[6] = $event => $options.goLink(_ctx.$attrs.detail.virtual_link)),
    target: "_blank"
  }, [$data.structImgdefaultValues.linkpic2 ? (_openBlock(), _createElementBlock("img", {
    key: 0,
    src: $data.structImgdefaultValues.linkpic2,
    alt: ""
  }, null, 8, _hoisted_96)) : (_openBlock(), _createElementBlock("span", _hoisted_97)), _createTextVNode(" " + _toDisplayString($data.structLabel.virtual_link), 1)])])) : _createCommentVNode("", true), _ctx.$attrs.detail.special_link ? (_openBlock(), _createElementBlock("li", _hoisted_98, [_createElementVNode("a", {
    onClick: _cache[7] || (_cache[7] = $event => $options.goLink(_ctx.$attrs.detail.special_link)),
    target: "_blank"
  }, [$data.structImgdefaultValues.linkpic3 ? (_openBlock(), _createElementBlock("img", {
    key: 0,
    src: $data.structImgdefaultValues.linkpic3,
    alt: ""
  }, null, 8, _hoisted_99)) : (_openBlock(), _createElementBlock("span", _hoisted_100)), _createTextVNode(" " + _toDisplayString($data.structLabel.special_link), 1)])])) : _createCommentVNode("", true), _ctx.$attrs.detail.route.length > 0 && _ctx.$attrs.detail.route[0].lng && $data.daohangflag ? (_openBlock(), _createElementBlock("li", _hoisted_101, [_createElementVNode("a", {
    onClick: _cache[8] || (_cache[8] = $event => $options.goLocation(_ctx.$attrs.detail)),
    target: "_blank"
  }, _cache[26] || (_cache[26] = [_createElementVNode("span", {
    class: "icon-location"
  }, null, -1), _createTextVNode("导航")]))])) : _createCommentVNode("", true), _ctx.$attrs.detail.audiodesc && _ctx.$attrs.detail.audiodesc.length > 0 ? (_openBlock(), _createElementBlock("li", _hoisted_102, [_createElementVNode("a", {
    onClick: _cache[9] || (_cache[9] = (...args) => $options.playaudiodesc && $options.playaudiodesc(...args)),
    target: "_blank"
  }, [_withDirectives(_createVNode(_component_el_icon, null, {
    default: _withCtx(() => [_createVNode(_component_Microphone)]),
    _: 1
  }, 512), [[_vShow, !$data.audiodescflag]]), _withDirectives(_createVNode(_component_el_icon, null, {
    default: _withCtx(() => [_createVNode(_component_Mute)]),
    _: 1
  }, 512), [[_vShow, $data.audiodescflag]]), _cache[27] || (_cache[27] = _createTextVNode("语音"))]), _createElementVNode("audio", {
    ref: "audiodesc",
    id: "audiodesc",
    style: {
      "width": "0",
      "height": "0"
    },
    autoplay: "",
    src: _ctx.$attrs.detail.audiodesc[0].url
  }, null, 8, _hoisted_103)])) : _createCommentVNode("", true)])], 2)) : _createCommentVNode("", true), _withDirectives(_createElementVNode("iframe", {
    id: "popiframe",
    src: $data.iframeurl,
    frameborder: "0"
  }, null, 8, _hoisted_104), [[_vShow, $data.linkcontainerflag]]), _withDirectives(_createVNode(_component_el_button, {
    class: "goback",
    onClick: $options.goback,
    round: ""
  }, {
    default: _withCtx(() => _cache[28] || (_cache[28] = [_createTextVNode("返回")])),
    _: 1
  }, 8, ["onClick"]), [[_vShow, $data.linkcontainerflag]])]);
}